import React, { useState, useEffect } from "react";
import { Form, Input, Button, Typography, Row, Col, message, Spin } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import _LoanOfficerService from "../../modules/LoanOfficerService";
import IntegerInput from "../../components/IntergerInput";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
const { Title, Text } = Typography;

const VerifyEmailOtpForLoanOfficer = () => {
  const history = useHistory();
  const [timer, setTimer] = useState(120);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
      const getQueryParams = () => {
        return new URLSearchParams(location.search);
      };
      const query = getQueryParams();
      const emailID = query.get('email');
    const bankAdminID = query.get('bid');
    const roleID = query.get('rid');
  let data = location.state;
  let emailId = "";
  if (data && data.email) {
    emailId = data.email;
  }

  const [email] = useState(emailId);

  // useEffect(() => {
  //   const countdown = setInterval(() => {
  //     setTimer(prev => {
  //       if (prev <= 1) {
  //         clearInterval(countdown);
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);
  //   return () => clearInterval(countdown);
  // }, []);

  useEffect(() => {
      if (timer > 0) {
        const interval = setInterval(() => setTimer((t) => t - 1), 1000);
        return () => clearInterval(interval);
      }
    }, [timer]);

 
  const onFinish = async (values) => {
    const reqObj = {
      Email: emailID,
      EmailOTP: values.otp,
      BankAdminId:bankAdminID,
      RoleId:roleID,
    }
    setLoading(true);
    try {
      const res = await _LoanOfficerService.confirmLoanOfficerEmailOTP(reqObj);
      if (res?.data?.IsSuccess) {
        message.success(res.data.Message);
         const obj = res?.data?.Obj || {};
        localStorage.setItem(SESSION_TOKEN, obj.AuthToken);
        localStorage.setItem("userRole", obj.Role);
        localStorage.setItem("IsLoanofficerFlag", JSON.stringify(true));
        localStorage.setItem("LoanOfficerId", obj.Id);

        localStorage.setItem("LoanOfficerEmailId", obj.Email);
        localStorage.setItem("RoleId", obj.RoleId);
        localStorage.setItem("BankAdminId", obj.BankAdminId);
        localStorage.setItem("BankerId", obj.Id);
        history.push({
          pathname: obj.IsUserExist
            ? routes.personalDetailsForLoanOfficer.path
            : routes.createNewPasswordForLoanOfficer.path,
          state: { email }
        });
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err)
    }
  };

  // const onBack = () => {
  //   history.push(routes.enterEmailForLoanOfficer.path);
  // };

  const handleResendOtp = async () => {
    const reqObj = {
      Email: email
    }
    setLoading(true);
    try {
      const res = await _LoanOfficerService.sendLoanOfficerVerifyEmailOTP(reqObj);
      if (res?.data.IsSuccess) {
        message.success(res.data.Message);
        setTimer(120); // Reset timer to 30 seconds
        setLoading(false);
      } else {
        setLoading(false);
        message.error(res.data.Message);
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <Spin spinning={loading}>
      <LeftLayout>
        <div className="subBackgroundLayout mt40">
          <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
            Credit Portal
          </Title>

          <Title level={4} style={{ marginBottom: 12 }}>
            Verify Your Email
          </Title>

          <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
            A six digit Verification Code was sent to <Text strong>{emailID}</Text>
          </Text>

          <Form layout="vertical" onFinish={onFinish} requiredMark={true}>
            <Form.Item
              label="Enter Verification Code" 
              name="otp"
              rules={[{ required: true, message: "OTP is required" },
              {
                pattern: /^\d{6}$/,
                message: "OTP must be a 6-digit number",
              },
              ]}
            >
              <IntegerInput
                maxLength={6}
                placeholder="Enter 6-digit OTP"
                autoComplete="one-time-code"
              />
            </Form.Item>

            <Form.Item>
              <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
                {/* <Button
                  onClick={onBack}
                  icon={<LeftOutlined />}
                >
                  Go Back
                </Button> */}
                <Button
                  type="primary"
                  htmlType="submit"
                  className="w100"
                >
                  Confirm OTP <RightOutlined />
                </Button>
              </div>
            </Form.Item>
          </Form>

          <Text type="secondary" style={{ display: "none", marginTop: 40 }}>
            Please wait 120 seconds before resending a new OTP:{" "}
            <span style={{ fontWeight: "bold"}}>
              00:{timer.toString().padStart(2, "0")}
            </span>
          </Text>
          <Button className="mt10 displayNone" shape="round" disabled={timer > 0} onClick={handleResendOtp}>Resend</Button>
        </div>
      </LeftLayout>
    </Spin>
  );
};

export default VerifyEmailOtpForLoanOfficer;
